/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Tiskové zprávy - CamAPS FX',
    titleMeta: 'Tiskové zprávy - CamAPS FX',
    descriptionMeta: 'Nejnovější tiskové zprávy a novinky z CamAPS FX.',
    keywords: 'camaps tiskové zprávy, camaps novinky, novinky o diabetické technologii',
    localeMeta: 'cs_cz',

    bannerTitle: 'Tiskové zprávy',
    bannerSubtitle: 'Zůstaňte informováni o našich nejnovějších oznámeních',

    contactText: 'Pro jakékoli tiskové dotazy kontaktujte <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Všechny tiskové zprávy jsou publikovány v angličtině.',

    download: 'Stáhnout',
    showMore: 'Zobrazit více',
    showLess: 'Zobrazit méně',
};

